// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type InstitutionFormValues } from '@client/banks/hooks/use-institution-form';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type InstitutionFormProps = {
  formId: string;
  onSubmit: (data: InstitutionFormValues) => void | Promise<void>;
  layout?: 'default' | 'drawer';
};

export const useInstitutionForm = ({
  layout = 'default',
}: InstitutionFormProps) => {
  const { control, watch, formState, handleSubmit } =
    useFormContext<InstitutionFormValues>();

  const { t } = useTranslation();

  const logoUrl = watch('logoUrl');

  const hasLogoUrl = useMemo(
    () => Boolean(logoUrl?.trim()) && !formState.errors.logoUrl,
    [formState.errors.logoUrl, logoUrl],
  );

  const isDrawerLayout = layout === 'drawer';

  return {
    control,
    handleSubmit,
    t,
    logoUrl,
    hasLogoUrl,
    isDrawerLayout,
  };
};
